import React, { useState, useEffect } from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import '../../../container/searchdoctors/search.css'
import veriuser from '../../../assets/images/Group 5276.png';
import rating from '../../../assets/images/rating.png'
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import Layout from '../../../layout/Layout'

import { useLocation, } from 'react-router-dom';
import './bookappointment.css'
import '../../../components/modal/modal.css'
import { getCaller } from '../../../services/api';
import moment from 'moment';
import { calculate_time_slot, convertTime12To24, dateFormat, generateImageURL, getDiscountedAmount, parseTime } from '../../../utils';
import { Avatar, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { constants } from '../../../utils/constants';


export default function BookAppointment(item) {
    const { state } = useLocation();
    const { loginId } = useParams();
    const [data, setData] = React.useState(null)
    const [calender, setCalender] = useState(null);
    const [date, setDate] = useState(null);
    const [slot, setSlot] = useState(null)
    const [slots, setSlots] = useState([]);
    const [disabledSlots, setDisabledSlots] = useState([])

    const rescheduled = state?.rescheduled;

    let selectedDoctor = state?.data;

    const navigate = useNavigate();

    const { t } = useTranslation() /* For translation */

    async function getUserData() {
        const resp = await getCaller('showPatientProfile');
        console.log(resp.data)
        if (resp && resp.data) {
            localStorage.setItem('patientId', resp.data.id)
        }
    }
    const disablePastDate = () => {
        const today = new Date();
        const dd = String(today.getDate() + 1).padStart(2, "0");
        const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        const yyyy = today.getFullYear();
        return yyyy + "-" + mm + "-" + dd;
    };

    function cancel() {
        navigate('/dashboard');
    }

    const handleCalenderDate = async date => {
        const formate_date = dateFormat(date?.$d);
        const response = await getCaller(`profile/availability?date=${formate_date}&userId=${data?.loginId}`);
        if (response?.error === false) {
            // setDate(value);
            setSlots(response?.data?.slots || [])
        } else {
            // setDate(null);
            setSlot(null);
        }
    }

    const handleSlotOnChange = (slot) => {
        const _slot = slot;
        setSlot(_slot)
    }

    const formatSlot = slot => {
        return moment(slot, "HH:mm:ss").format("hh:mm A")
    }

    const fetchDoctorPublicProfile = async () => {
        const response = await getCaller(`doctor/profile/public/${loginId}`)
        setData(response?.data);
    }

    const fetchOldAppointment = async () => {
        const { appointmentId } = rescheduled;
        const response = await getCaller(`getOneAppointment/${appointmentId}`)
        if (response?.data) {
            const [slot] = response?.data?.slot;
            setDate(slot?.date || '');
            handleCalenderDate({ target: { value: slot?.date } })
        }
    }

    const handleCalenderChange = (newValue) => {
        setCalender(newValue)
        handleCalenderDate(newValue)
    }

    const handleDisabledDates = date => {

        /* handling if it is a weekend */
        if (date.day() === 0 || date.day() === 6) {
            return true;
        }
        let currentDate = date.format(constants.DATABASE_DATE_FORMAT)
        const currentDay = date.format(constants.USER_DATE_FORMAT);
        console.log("🚀 ~ file: BookAppointment.jsx:109 ~ handleDisabledDates ~ currentDay", currentDay)
        let isPassed = false;
        if (!disabledSlots || disabledSlots.length === 0) {
            return false;
        }


        const index = disabledSlots.findIndex(slot => slot?.day === currentDay)
        // console.log("🚀 ~ file: BookAppointment.jsx:116 ~ handleDisabledDates ~ index", index)
        if (disabledSlots[index]?.avail === false) {
            isPassed = true;
        }


        // disabledSlots.forEach(slot => {
        //     const toMatch = moment(slot?.slot?.date).format(constants.DATABASE_DATE_FORMAT);
        //     if (toMatch == currentDate) {
        //         isPassed = true;
        //         return
        //     }
        // })
        return isPassed;
    }

    const fetchCurrentMonthAvailability = async (month, year) => {
        const _month = month ?? moment().month();
        const _year = year ?? moment().year();
        console.log("🚀 ~ file: BookAppointment.jsx:122 ~ fetchCurrentMonthAvailability ~ _month", _month)
        console.log("🚀 ~ file: BookAppointment.jsx:124 ~ fetchCurrentMonthAvailability ~ _year", _year)
        const response = await getCaller(`profile/availability/monthly?month=${_month}&doctorId=${loginId}&year=${_year}`)
        setDisabledSlots(response?.data || [])
    }

    const handleMonthChange = date => {
        fetchCurrentMonthAvailability(date.month(), date.year())
    }

    React.useEffect(() => {
        if (selectedDoctor === null) {
            navigate('/searchdoctor')
        }
        else if (selectedDoctor === undefined && localStorage.getItem('docData') === undefined) {
            navigate('/searchdoctor')
        }
        else {
            if (selectedDoctor === undefined) {
                try {
                    setData(localStorage.getItem('docData') && JSON.parse(localStorage.getItem('docData')))
                } catch { setData({}) }
            }
            else {
                setData(selectedDoctor)
            }
        }
        getUserData();
        fetchDoctorPublicProfile();
        fetchCurrentMonthAvailability();
    }, [])

    useEffect(() => {
        rescheduled && fetchOldAppointment()
    }, [data])

    return (
        <>{
            data && <Layout>
                <div className="step-c">
                    <div className="stepper">
                        <div className="stepper-content">

                            <Stepper  >
                                <Step>
                                    <StepLabel className='not-selectable'> Appointment </StepLabel>
                                </Step>
                                <Step>
                                    <StepLabel className='not-selectable'> Fill Details </StepLabel>
                                </Step>
                                <Step>
                                    <StepLabel className='not-selectable'> Payment </StepLabel>
                                </Step>

                            </Stepper>
                        </div>
                        <div className='step-border' ></div>

                        <div className="first-border">

                            <p className="first-para">Doctor Details</p>
                            <div className="first-content" key={data?.loginId}>
                                <div className='doctor-search-img-1'>
                                    {/* <img src={generateImageURL(data?.url)} alt="" /> */}
                                    {/* <Avatar
                                        className={'doctor-search-img-1'}
                                        src={generateImageURL(data?.url)}
                                        alt={data?.name}
                                    /> */}
                                    <Avatar
                                        className="doctor-img"

                                        src={generateImageURL(data?.url)}
                                        alt={data?.name}
                                    />
                                </div>
                                <div className="first-body">
                                    <div className='icon-first-user-container'>
                                        <div className='icon-left' style={{
                                            position: 'relative'
                                        }}>
                                            <img src={rating} alt="" className='star'
                                                style={{
                                                    width: '70px',
                                                    height: '25px'
                                                }}
                                            />
                                            <p
                                                style={{
                                                    position: 'absolute',
                                                    bottom: 0,
                                                    left: 30,
                                                    fontWeight: '600',
                                                    fontSize: '0.87rem'
                                                }}
                                            > {data && Number(data.reviews).toPrecision(2) || '0'} </p>
                                        </div>
                                        <div className='icon-right'>
                                            <img src={veriuser} alt="" />  </div>
                                    </div>
                                    <div className=''>
                                        <h4 style={{
                                            textTransform: 'capitalize'
                                        }}>{data?.name} </h4>
                                        <p className="first-child-para">{data?.specialization} | {data?.data?.startTime} - {data?.data?.endTime} </p>
                                        <div className='first-sar'>
                                            <p>SAR {Array.isArray(data?.service) && data?.service[0]?.fees}</p>
                                            {data?.offer?.["coupons.discount"] && <del className='del'>SAR {data?.fees}</del>}
                                            {data?.offer?.["coupons.discount"] && <button>{data?.offer?.["coupons.discount"]}% Discount</button>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="first-book-input">
                                <div className="first-input-content">
                                    <label htmlFor="date" className='not-selectable'> Date & Time </label> <br />
                                    <DatePicker
                                        disablePast
                                        value={calender}
                                        onChange={handleCalenderChange}
                                        shouldDisableDate={disabledSlots && handleDisabledDates}
                                        onMonthChange={handleMonthChange}
                                        // onChange={(newValue) => {
                                        //     setValue(newValue);
                                        // }}
                                        renderInput={(params) => <TextField size='sm' {...params} />}
                                    />
                                    {/* <input type="date" className='first-date'
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    value={date}
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            // min={disablePastDate()}
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    onChange={handleCalenderDate} /> */}
                                </div>
                                <div className="first-input-content">
                                    <label htmlFor="date" className='not-selectable'> Timeslot </label> <br />
                                    <select
                                        name=""
                                        id=""
                                        className='first-date-time'
                                        onChange={event => setSlot(JSON.parse(event.target.value))}
                                        disabled={slots.length === 0}
                                    >
                                        <option value=""> Select </option>
                                        {
                                            slots.map(slot => {
                                                return <option
                                                    onClick={() => handleSlotOnChange(slot)}
                                                    value={JSON.stringify(slot)}>
                                                    {formatSlot(slot?.start)} - {formatSlot(slot?.end)}
                                                </option>
                                            })
                                        }

                                    </select>
                                </div>
                            </div>
                        </div>
                        <React.Fragment>
                            <div className="first-btn-content">
                                <button className='step-cancel-btn'
                                    onClick={cancel}
                                >
                                    {t('cancel')}
                                </button>
                                <div className="first-back">
                                    {/* <button className='back'> Back </button> */}
                                    <button className='proceed-btn'
                                        disabled={!calender || !slot}
                                        onClick={() => {
                                            navigate('/filldetails', {
                                                state: {
                                                    selectedDoctor: data,
                                                    slotDetails: {
                                                        date: calender && calender.format(constants.USER_DATE_FORMAT),
                                                        slot
                                                    },
                                                    rescheduled: rescheduled
                                                }
                                            });
                                            localStorage.setItem('docData', JSON.stringify(selectedDoctor));
                                            localStorage.setItem('date', JSON.stringify({ date: date, slot: slot }))
                                        }}>
                                        Proceed
                                    </button>
                                </div>
                            </div>
                        </React.Fragment>


                    </div>
                </div>
            </Layout>
        }
        </>
    );
}
